import OpenInNew from '@mui/icons-material/OpenInNew';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';

import { ConnectedAccount, ExternalService } from '@/api/userAccount';
import { Timestamp } from '@/components/data/Timestamp';

const border = '1px solid var(--divider, rgba(192, 192, 192, 0.8))';

const connectedAccountConfigs: Record<ExternalService, { title: string; href: string }> = {
    tether: {
        title: 'Tether Dashboard (Online Oceans)',
        href: 'https://tether.onlineoceans.com',
    },
};

export const ConnectedAccountDisplay = ({ connectedAccount }: { connectedAccount: ConnectedAccount }) => {
    const connectedAccountConfig = useMemo(() => {
        if (!(connectedAccount.external_service in connectedAccountConfigs)) {
            return null;
        }
        return connectedAccountConfigs[connectedAccount.external_service];
    }, [connectedAccount]);

    if (!connectedAccountConfig) {
        return null;
    }

    return (
        <Box sx={{ border, p: 2, alignItems: 'center' }}>
            <Stack direction="row" justifyContent="space-between">
                <Stack gap={1} alignItems="flex-start">
                    <Typography variant="h5">{connectedAccountConfig.title}</Typography>
                    <Typography variant="caption" color="textSecondary">
                        <>Connected on </>
                        <Timestamp unit="date" value={connectedAccount.created_at} />
                    </Typography>
                    <Button variant="text" href={connectedAccountConfig.href} sx={{ m: -1 }}>
                        <Stack direction="row" gap={1} alignItems="center">
                            <Typography variant="h5">Go to Dashboard</Typography>
                            <OpenInNew sx={{ fontSize: '18px' }} />
                        </Stack>
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};
